import axios from "axios";
import { API_BASE_URL } from "../config";
import { getAuthHeaders } from "./developerApi";

const base = `${API_BASE_URL}/finance-control`;
const get = (path) => axios.get(`${base}${path}`, getAuthHeaders()).then((r) => r.data);
const post = (path, payload = {}) => axios.post(`${base}${path}`, payload, getAuthHeaders()).then((r) => r.data);
const put = (path, payload) => axios.put(`${base}${path}`, payload, getAuthHeaders()).then((r) => r.data);
const del = (path) => axios.delete(`${base}${path}`, getAuthHeaders()).then((r) => r.data);
export const getFinanceLimits = () => get("/limits");
export const createFinanceLimit = (data) => post("/limits", data);
export const updateFinanceLimit = (id, data) => put(`/limits/${id}`, data);
export const deleteFinanceLimit = (id) => del(`/limits/${id}`);
export const testFinanceLimit = (id) => post(`/limits/${id}/test-notification`);
export const getReconciliations = () => get("/reconciliations");
export const createReconciliation = (data) => post("/reconciliations", data);
export const updateReconciliation = (id, data) => put(`/reconciliations/${id}`, data);
export const deleteReconciliation = (id) => del(`/reconciliations/${id}`);
export const recalculateReconciliation = (id, data) => post(`/reconciliations/${id}/recalculate`, data);
export const testReconciliation = (id) => post(`/reconciliations/${id}/test-notification`);
export const getReconciliationSnapshots = (id) => get(`/reconciliations/${id}/snapshots`);
export const getFinanceSettings = () => get("/settings");
export const updateFinanceSettings = (data) => put("/settings", data);
export const getFinanceNotifications = () => get("/notifications");
